import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import StudentName from './student.name';
import { studentApi } from './student.queries';

export default function StudentAutocomplete(props) {
	const useGetAll = studentApi.useGetAll();
	const students = useGetAll.data || [];

	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		if (students.length && props?.defaultValue) {
			setSelected(students.filter((s) => props.defaultValue.includes(s.id)));
		}
	}, [students, props?.defaultValue]);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (e, newValue) => {
		setSelected(newValue);
		props?.onChange?.(newValue);
	};

	return (
		<Autocomplete
			multiple
			open={open}
			onOpen={handleOpen}
			onClose={handleClose}
			onChange={handleChange}
			getOptionLabel={(option) => option.name}
			getOptionKey={(option) => option.id}
			value={selected}
			options={students}
			loading={useGetAll.isPending}
			renderInput={(params) => (
				<TextField {...params} label="Filter Students..." slotProps={{
					input: {
						...params.InputProps,
						endAdornment: (
							<React.Fragment>
								{useGetAll.isPending ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					},
				}} />
			)}
			renderOption={(props, option, { selected }) => {
				const { key, ...optionProps } = props;
				return (
					<li key={key} {...optionProps}>
						<StudentName student={option} hideLink={true} />
					</li>)
			}}
		/>
	);
}